var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-story-container"},[_c('awards',{attrs:{"projectAwards":_vm.projectAwards}}),_vm._v(" "),_c('div',{staticClass:"image story",class:{loading: _vm.image.loading || (_vm.isBlank && _vm.isVisible) || _vm.isRowLoading,
       loaded: !_vm.isRowLoading && _vm.image.loaded || _vm.image.error,
       'overlay-exist-ysc': _vm.$isYSC},style:(_vm.imageBackground)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }